import { render } from "./CreateOrEditBid.vue?vue&type=template&id=92764f3c&lang=pug"
import script from "./CreateOrEditBid.vue?vue&type=script&lang=ts"
export * from "./CreateOrEditBid.vue?vue&type=script&lang=ts"
script.render = render

export default script